import React from 'react';
import { observer } from 'mobx-react';
import DndItem from './DndItem';
import DndListStore from '../../stores/DndListStore';

@observer
export default class DndItems extends React.Component {
  constructor(props) {
    super(props);

    this.renderDndItem = this.renderDndItem.bind(this);
  }

  renderDndItem(dndItem) {
    return (
      <DndItem className={'dndItem'} onMove={DndListStore.move}
        data={dndItem} key={`dndItem${dndItem.id}`}
      >
        {dndItem.name}
      </DndItem>
    );
  }

  render() {
    const dndItems = this.props.items;

    return <ul className={'dndItems'}>{dndItems.map(this.renderDndItem)}</ul>;
  }
}

// DndItems.propTypes = {
  // items: PropTypes.object, // ObservableArray [{ id, name }]
// };



// WEBPACK FOOTER //
// ./src/components/DnD/DndItems.js